var coucouGallery, moveNext, movePrev;

coucouGallery = function () {
  $(".coucou-gallery").each(function () {
    var $first, $this;
    $this = $(this);
    $first = $this.children("li:first-child");
    return $first.imagesLoaded(function () {
      return $first.addClass("active");
    });
  });
  $(".coucou-gallery-next").on("click", function (e) {
    e.preventDefault();
    return moveNext($(this).parent().find("ul.coucou-gallery"));
  });
  $(".coucou-gallery-prev").on("click", function (e) {
    e.preventDefault();
    return movePrev($(this).parent().find("ul.coucou-gallery"));
  });
  return $(".coucou-gallery-item").on("click", function (e) {
    e.preventDefault();
    return moveNext($(this).parent("ul.coucou-gallery"));
  });
};

moveNext = function (ul) {
  var $current, $next;
  $current = ul.children("li.active");
  if ($current.is(":last-child")) {
    $next = ul.children("li:first-child");
  } else {
    $next = $current.next();
  }
  return $next.imagesLoaded(function () {
    $current.removeClass("active");
    return $next.addClass("active");
  });
};

movePrev = function (ul) {
  var $current, $next;
  $current = ul.children("li.active");
  if ($current.is(":first-child")) {
    $next = ul.children("li:last-child");
  } else {
    $next = $current.prev();
  }
  return $next.imagesLoaded(function () {
    $current.removeClass("active");
    return $next.addClass("active");
  });
};

$(document).on("page:load", coucouGallery);

$(function () {
  return coucouGallery();
});
